import React from 'react';
import FAQ from '../components/FAQ';

const FAQPage = () => {
  return (
    <div className="pt-20">
      <FAQ />
    </div>
  );
};

export default FAQPage;